// eslint-disable-next-line import/no-cycle
import { getFloors } from "@/api/deployment";

const business = {
  state: {
    floors: null,
    deviceTypeChecked: null,
    floorChecked: null,
    deviceChecked: null,
    autoSaveWords: ""
  },

  mutations: {
    SET_FLOORS: (state, floors) => {
      state.floors = floors;
    },
    SET_DEVICE_TYPE_CHECKED: (state, deviceTypeChecked) => {
      state.deviceTypeChecked = deviceTypeChecked;
    },
    SET_FLOOR_CHECKED: (state, floorChecked) => {
      state.floorChecked = floorChecked;
    },
    SET_DEVICE_CHECKED: (state, deviceChecked) => {
      state.deviceChecked = deviceChecked;
    },
    SET_AUTO_SAVE_WORDS: (state, autoSaveWords) => {
      state.autoSaveWords = autoSaveWords;
    }
  },

  actions: {
    // 获取店铺摄像头信息
    GetFloors({ commit, state, dispatch }, params) {
      return new Promise((resolve, reject) => {
        getFloors(params)
          .then(res => {
            commit("SET_FLOORS", res.data);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    actionDeviceTypeChecked({ commit, state, dispatch }, params) {
      commit("SET_DEVICE_TYPE_CHECKED", params);
    },
    actionFloorChecked({ commit, state, dispatch }, params) {
      commit("SET_FLOOR_CHECKED", params);
    },
    actionDeviceChecked({ commit, state, dispatch }, params) {
      commit("SET_DEVICE_CHECKED", params);
    },
    actionAutoSaveWords({ commit, state, dispatch }, params) {
      commit("SET_AUTO_SAVE_WORDS", params);
    }
  }
};

export default business;
